import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { Link } from '@/i18n/routing';
import { Breadcrumbs, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
  breadcrumbsLink,
  breadcrumbsList,
  breadcrumbsSeparator,
  containerWrapper,
  icon,
  main,
} from '@mage-ui/styled-system/recipes';
import { useContext } from 'react';

export const Main = ({
  children,
  layout,
  breadcrumbs = [],
  language,
  ...props
}) => {
  const { st } = useContext(StaticTextContext);

  return (
    <main className={cx(main(), layout)} {...props}>
      {layout !== 'home-layout'
        ? breadcrumbs.length > 0 &&
          breadcrumbs && (
            <Breadcrumbs
              className={{
                list: breadcrumbsList(),
                separator: breadcrumbsSeparator(),
              }}
              separator={
                <Icon name='arrow_right' classNames={icon({ size: 's' })} />
              }
            >
              {breadcrumbs.map((item, index) => (
                <Breadcrumbs.Item key={item?.title}>
                  <Link
                    href={index === 0 ? '/' : item?.slug}
                    className={breadcrumbsLink()}
                  >
                    {index === 0 ? st('breadcrumb.home') : item?.title}
                  </Link>
                </Breadcrumbs.Item>
              ))}
            </Breadcrumbs>
          )
        : null}
      <div className={containerWrapper({ size: 'narrow' })}>{children}</div>
    </main>
  );
};
